import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import { StaticImage } from 'gatsby-plugin-image';
import { SectionFieldContainerProps } from '../typings';

const Signature: React.FC<SectionFieldContainerProps> = (signatureProps) => {
  const { sectionFieldDetails } = signatureProps;
  return (
    <div>
      <Typography variant='body1' color='primary'>
        {sectionFieldDetails.name}
        {sectionFieldDetails.isMandatory && <span>*</span>}
      </Typography>
      <br />
      <StaticImage layout='constrained' placeholder='tracedSVG' src='../assets/Signature/tolstoy-romerio.svg' alt='sample signature' />
    </div>
  );
};

export default Signature;
